module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gb-wls-77f90d8e620af4d9604d4da7c7f49346.svg";